import React, { useEffect, useState } from 'react';
import { ArrowUpRightIcon } from 'lucide-react';
import { seoLaunchSteps } from '../../data/seo';
import { Card } from '../ui/Card';
const storageKey = 'artistos-seo-launch-progress';
function getCompleted(): string[] {
  try {
    const stored = window.localStorage.getItem(storageKey);
    const parsed: unknown = stored ? JSON.parse(stored) : [];
    return Array.isArray(parsed) ? parsed as string[] : [];
  } catch {
    return [];
  }
}
export function SeoLaunchSteps() {
  const [completed, setCompleted] = useState<string[]>(() => getCompleted());
  useEffect(() => {
    try {
      window.localStorage.setItem(storageKey, JSON.stringify(completed));
    } catch {
      // Progress tracking is a convenience only.
    }
  }, [completed]);
  const toggle = (id: string) => setCompleted(current => current.includes(id) ? current.filter(item => item !== id) : [...current, id]);
  return <div className="space-y-3" data-id="element-558" data-mp="1c6wbhu8rqawt">
      {seoLaunchSteps.map(step => {
      const done = completed.includes(step.id);
      return <Card key={step.id} className={`p-4 transition-colors duration-150 ease-out ${done ? 'opacity-60' : ''}`} data-id="element-559" data-mp="lpojql95sao6">
            <div className="flex flex-wrap items-start justify-between gap-3" data-id="element-560" data-mp="10ekskkj1hrpu">
              <label className="flex cursor-pointer items-start gap-3" data-id="element-561" data-mp="vfhy1u0or3w4">
                <input type="checkbox" checked={done} onChange={() => toggle(step.id)} className="mt-0.5 h-4 w-4 shrink-0 accent-[#d97742]" data-id="element-562" data-mp="vhb2r3rqne1h" />
                <span data-id="element-563" data-mp="hocskbamzhdv">
                  <span className={`block text-[14px] font-semibold text-white ${done ? 'line-through' : ''}`} data-id="element-564" data-mp="houvtrvpuvva">
                    {step.title}
                  </span>
                  <span className="mt-0.5 block text-[11.5px] font-medium uppercase tracking-wide text-zinc-600" data-id="element-565" data-mp="1t2qdb7a3fgpo">
                    {step.minutes}
                  </span>
                </span>
              </label>
              <a href={step.linkUrl} target="_blank" rel="noreferrer" className="inline-flex shrink-0 items-center gap-1.5 rounded-lg border border-white/[0.1] px-2.5 py-1.5 text-[11.5px] font-medium text-zinc-300 transition-colors hover:border-accent/40 hover:text-white" data-id="element-566" data-mp="1v7vbh7s3brkz">
                {step.linkLabel} <ArrowUpRightIcon className="h-3.5 w-3.5" data-id="element-567" data-mp="1cgm537dm9ixm" />
              </a>
            </div>

            <p className="ml-7 mt-2 text-[12.5px] leading-relaxed text-zinc-400" data-id="element-568" data-mp="1hfoxnscetwop">{step.summary}</p>

            <ol className="ml-7 mt-3 space-y-1.5" data-id="element-569" data-mp="1mes33dway4x7">
              {step.steps.map((item, index) => <li key={item} className="flex gap-2.5 text-[12.5px] leading-relaxed text-zinc-400" data-id="element-570" data-mp="1r5i8gr4qa7rw" data-mpi={index}>
                  <span className="shrink-0 font-medium text-zinc-600" data-id="element-571" data-mp="tqcqey0n7yp1">{index + 1}.</span>
                  {item}
                </li>)}
            </ol>
          </Card>;
    })}
    </div>;
}